import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__top">
          {/* Brand */}
          <div className="footer__brand">
            {/* <div className="footer__logo">
              <div className="footer__logo-icon">A</div>
              <div>
                <span className="footer__logo-name">AJERA</span>
                <span className="footer__logo-tag">Infotech</span>
              </div>
            </div> */}
            <div className="footer__logo">
              <img 
                src="/9 - Copy.png" 
                alt="AJERA Logo" 
                className="footer__logo-img"
              />
            </div>
            <p className="footer__brand-desc">
              Building tomorrow's technology today. End-to-end digital solutions
              for startups, SMBs and enterprises.
            </p>
            <div className="footer__socials">
              <a href="https://www.instagram.com/ajera_infotech?igsh=MTV1dDE1bTVmbG1ueQ==" target="_blank" rel="noopener noreferrer" className="footer__social footer__social--ig" aria-label="Instagram">IG</a>
              <a href="https://wa.me/919751772429" target="_blank" rel="noopener noreferrer" className="footer__social footer__social--wa" aria-label="WhatsApp">WA</a>
              <a href="https://www.linkedin.com/company/ajera-infotech/" target="_blank" rel="noopener noreferrer" className="footer__social footer__social--li" aria-label="LinkedIn">IN</a>
              {/* <a href="https://youtube.com/@ajerait" target="_blank" rel="noopener noreferrer" className="footer__social footer__social--yt" aria-label="YouTube">YT</a> */}
            </div>
          </div>

          {/* Services */}
          <div className="footer__col">
            <h4 className="footer__col-title">Services</h4>
            <ul className="footer__links">
              <li><Link to="/about#web">Web Development</Link></li>
              <li><Link to="/about#mobile">Mobile App Dev</Link></li>
              <li><Link to="/about#ai">AI & ML</Link></li>
              <li><Link to="/about#cloud">Cloud & DevOps</Link></li>
              <li><Link to="/about#security">Cyber Security</Link></li>
              <li><Link to="/about#design">UI/UX Design</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div className="footer__col">
            <h4 className="footer__col-title">Company</h4>
            <ul className="footer__links">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/about#team">Our Team</Link></li>
              <li><Link to="/about#values">Our Values</Link></li>
              <li><Link to="/careers">Careers</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Careers */}
          <div className="footer__col">
            <h4 className="footer__col-title">Careers</h4>
            <ul className="footer__links">
              <li><Link to="/careers#fulltime">Full Time Jobs</Link></li>
              <li><Link to="/careers#internship">Internship</Link></li>
              <li><Link to="/careers#courses">Courses</Link></li>
            </ul>
            <h4 className="footer__col-title" style={{ marginTop: "24px" }}>Contact</h4>
            <ul className="footer__links">
              <li><a href="mailto:contact@ajeragroup.com">contact@ajeragroup.com</a></li>
              <li><a href="tel:+919751772429">+91 9751772429</a></li>
              <li>Tamil Nadu, India</li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <p>© {new Date().getFullYear()} AJERA Infotech. All rights reserved.</p>
          <div className="footer__bottom-links">
            <a href="#privacy">Privacy Policy</a>
            <a href="#terms">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
